import { useStore, useStoreMap } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { inspectionModel } from '~/features/Inspection'
import { Avatar } from '~/shared/ui/Avatar'
import {
  DriverFullName,
  EmptyRentalContract,
  Wrapper,
  Skeleton,
  CarPlateNumber,
  RentalContractWrapper,
} from './styled'

export function CarData() {
  const { t } = useTranslation()

  const isCarLoading = useStore(inspectionModel.requestCarFx.pending)
  const plateNumber = useStoreMap(inspectionModel.$car, (car) =>
    car?.getPlateNumber(),
  )
  const driverFullName = useStoreMap(inspectionModel.$car, (car) =>
    car?.getDriverFullName(),
  )
  const photoDriver = useStoreMap(inspectionModel.$car, (car) =>
    car?.getPhotoDriver(),
  )

  const rentalContract = driverFullName ? (
    <RentalContractWrapper>
      <Avatar url={photoDriver?.originalUrlDownload} />
      <DriverFullName>{driverFullName}</DriverFullName>
    </RentalContractWrapper>
  ) : (
    <EmptyRentalContract>
      {t('alert.missing rental agreement with driver')}
    </EmptyRentalContract>
  )
  return (
    <>
      {isCarLoading ? (
        <Skeleton />
      ) : (
        <Wrapper>
          <CarPlateNumber>{plateNumber}</CarPlateNumber>
          {rentalContract}
        </Wrapper>
      )}
    </>
  )
}
